export interface InterestsProps {
  name: string
  emoji: string
}

export const interests: InterestsProps[] = [
  { name: 'Animation',                   emoji: '🎨' },
  { name: 'Automobile & Mobility',       emoji: '🚘' },
  { name: 'Comedy & Satire',             emoji: '😂' }, 
  { name: 'Cinema & Film',               emoji: '🎬' }, 
  { name: 'Education & Learning',        emoji: '📖' }, 
  { name: 'Other Entertainment',         emoji: '🎭' }, 
  { name: 'Lifestyle & Vlogs',           emoji: '🤳' }, 
  { name: 'Music',                       emoji: '🎤' }, 
  { name: 'Politics',                    emoji: '🗣️' }, 
  { name: 'Business & Entrepreneurship', emoji: '💡' }, 
  { name: 'Science & Technology',        emoji: '🤖' }, 
  { name: 'Other Sports',               emoji: '🏅' },  
  { name: 'Travel & Events',            emoji: '🧳' },  
  { name: 'Food & Cooking',             emoji: '👨‍🍳' },  
  { name: 'Devotional & Spiritual',     emoji: '🙏' },  
  { name: 'Gaming & Esports',           emoji: '🎮' },  
  { name: 'Cricket',                    emoji: '🏏' },  
  { name: 'Football / Soccer',          emoji: '⚽' },  
  { name: 'Crime & Investigation',      emoji: '🕵️' },  
  { name: 'Finance & Investing',        emoji: '💰' },  
  { name: 'Medical',                    emoji: '🩺' },  
  { name: 'Beauty & Fashion',           emoji: '💅' },  
  { name: 'Dance',                      emoji: '🕺' },  
  { name: 'DIY & How-To',              emoji: '🔨' },  
  { name: 'Fitness & Wellness',         emoji: '🏋️' }, 
  { name: 'History & Culture',          emoji: '📜' }, 
  { name: 'Kids & Family',             emoji: '🧸' },  
  { name: 'Nature & Environment',       emoji: '🌿' }, 
  { name: 'News & Current Affairs',     emoji: '📺' }, 
  { name: 'Pets & Animals',            emoji: '🐾' },  
  { name: 'Real Estate',               emoji: '🏡' },  
  { name: 'Personal Development',       emoji: '🧠' }, 
];



export interface CommunicationLanguagesProps {
  name: string
}

export const communicationLanguages: CommunicationLanguagesProps[] = [
  { name: 'English' },
  { name: 'Bhojpuri' },
  { name: 'Spanish' },
  { name: 'Hindi' },
  { name: 'Arabic' },
  { name: 'Bengali' },
  { name: 'Portuguese' },
  { name: 'Russian' },
  { name: 'Japanese' },
  { name: 'German' },
  { name: 'Mandarin Chinese' },
  { name: 'French' },
  { name: 'Telugu' },
  { name: 'Marathi' },
  { name: 'Turkish' },
  { name: 'Tamil' },
  { name: 'Urdu' },
  { name: 'Gujarati' },
  { name: 'Polish' },
  { name: 'Malayalam' },
  { name: 'Kannada' },
  { name: 'Odia' },
  { name: 'Cantonese' },
]

export interface OnboardingStepProps {
  title: string
  description: string
  subtitle?: string
  subdescription?: string
  thirdStepDescription?: string
}

export const onboardingData: OnboardingStepProps[] = [
  {
    title: 'Welcome to LYKSTAGE!',
    description:
      'Help us make your experience awesome by giving us some information :)',
    subtitle: 'Select your interests.',
    subdescription:
      'This helps us recommend more relevant content. Please choose at least 3.',
  },
  {
    title: 'Welcome to LYKSTAGE!',
    description:
      'Help us make your experience awesome by giving us some information :)',
    subtitle: 'Choose Preferred Language(s) for content.',
    subdescription:
      'We will try to recommend content that is in these languages.',
  },
  {
    title: 'Just give us a few more details :)',
    description: 'This will help us optimize your experience better',
  },
  {
    title: 'Start earning with your watchtime!',
    description:
      'With LYKSTAGE, viewers are rewarded for their watchtime. A unit of watch time can be defined as a block of 30 sec uninterrupted video viewing.',
    // subtitle: '*Rs. 1 = 5 LYK Coins',
    subtitle: 'US$ 1 = 50 LYK Coins',
    subdescription: 'LYK Coins can be converted into real currency.',
    thirdStepDescription: 'Don’t understand how this works? We’ll show you!',
  },
]
